import React, { useState } from "react";
import {
	Input,
	Button,
	Link,
	FluentProvider,
	webLightTheme,
	Field,
    Label,
	Radio,
	RadioGroup,
	Checkbox,
} from "@fluentui/react-components";
import {
	ColorPicker,
	ColorSlider,
	AlphaSlider,
	ColorPickerProps,
	ColorArea,
} from "@fluentui/react-color-picker-preview";
// import "./PassGenerator.css";
import { apiCallPOST } from "../api/Api";
import ColorPickerPopup from "../components/ColorPicker";
import FileInputWithPreview from "../components/FileInputWithPreview";


// function PassGenerator() {
const PassGenerator = () => {
	// Stato per il tipo di pass: apple o google
	const [passType, setPassType] = useState("apple");
	const [isDefault, setIsDefault] = useState(true);
	
	// Stato per i campi di testo del form
	const [formData, setFormData] = useState({
		isDefault: true,
		serialNumber: "",
		organizationName: "",
		description: "",
		logoText: "",
		backgroundColor: "",
		foregroundColor: "",
		labelColor: "",
		barcodeMessage: "",
		// Campi specifici per Google Wallet
		accountId: "",
		accountName: "",
		issuerName: "",
		programName: "",
	});

	// Stato per salvare i colori selezionati per i vari input
	const [backgroundColor, setBackgroundColor] = useState("rgb(255, 255, 255)");
	const [foregroundColor, setForegroundColor] = useState("rgb(0, 0, 0)");
	const [labelColor, setLabelColor] = useState("rgb(0, 0, 0)");

	// Stato per la gestione dei file caricati
	const [iconFile, setIconFile] = useState(null);
	const [logoFile, setLogoFile] = useState(null);
	const [stripFile, setStripFile] = useState(null);
	const [qrCodeFile, setQrCodeFile] = useState(null);

	// Stato per memorizzare l'URL di download restituito dal backend
	const [downloadUrl, setDownloadUrl] = useState("");

	// Gestore delle modifiche ai campi di testo
	const handleChange = (e) => {
		const { name, value } = e.target;
		setFormData((prevData) => ({
			...prevData,
			[name]: value,
		}));
	};

	// Gestore delle modifiche per il caricamento dei file
	const handleFileChange = (file) => {
        console.log(file);
		// const { name, files } = file;
        const name = file.name;
		// if (files.length > 0) {
        if (file) {
			switch (name) {
				case "iconFile":
					// setIconFile(files[0]);
					setIconFile(file);
					break;
				case "logoFile":
					// setLogoFile(files[0]);
                    setLogoFile(file);
					break;
				case "stripFile":
					// setStripFile(files[0]);
                    setStripFile(file);
					break;
				case "qrCodeFile":
					// setQrCodeFile(files[0]);
                    setQrCodeFile(file);
					break;
				default:
					break;
			}
		}
	};

	// Gestore dell'invio del form
	const handleSubmit = async (e) => {
		e.preventDefault();

		// Definisci l'URL base del backend (assicurati di usare il protocollo corretto, ad esempio https se hai SSL)
		const backendUrl = "https://api.marroristoranti.com";

		// Selezione dell'endpoint in base al tipo di pass
		// const api =
		// 	passType === "apple"
		// 		? `${backendUrl}/api/generate/apple`
		// 		: `${backendUrl}/api/generate/google`;
		const api =
			passType === "apple"
				? '/api/generate/apple'
				: '/api/generate/google';

		// Creazione di un oggetto FormData per supportare sia campi testuali che file
		let objParams = {
			function: passType === "apple" ? "generate/apple" : "generate/google",
		}
		// let data = new FormData();
		// data.append("passType", passType);
		Object.keys(formData).forEach((key) => {
			console.log(key, formData[key]);
			objParams[key] = formData[key];
		});

		// Aggiunge i file se sono stati caricati
		// if (iconFile) data.append("iconFile", iconFile);
		// if (logoFile) data.append("logoFile", logoFile);
		// if (stripFile) data.append("stripFile", stripFile);
		// if (qrCodeFile) data.append("qrCodeFile", qrCodeFile);

		console.log("Endpoint:", JSON.stringify(api));
		console.log("Body inviato:", JSON.stringify(objParams));
		
		let result = await apiCallPOST(objParams, api, backendUrl);

		console.log("Risultato chiamata:", JSON.stringify(result));
		// try {
		// 	const response = await fetch(endpoint, {
		// 		method: "POST",
		// 		body: data, // Non è necessario specificare il Content-Type, il browser lo gestisce
		// 	});

		// 	if (!response.ok) {
		// 		throw new Error("Errore nella generazione del pass");
		// 	}

			// const result = await response.json();
			setDownloadUrl(result.downloadUrl);
		// } catch (error) {
		// 	console.error("Errore:", error);
		// 	alert("Si è verificato un errore nella generazione del pass.");
		// }
	};

	return (
		<div
		// className="PassGenerator"
		>
			<h1>Generatore di Pass per Apple e Google Wallet</h1>

			{/* Selezione del tipo di pass */}
			<Field label="Crea il pass per:">
				<RadioGroup
					value={passType}
					onChange={(_, data) => setPassType(data.value)}
				>
					<Radio value="apple" label="Apple Wallet" />
					<Radio value="google" label="Google Wallet" />
				</RadioGroup>
			</Field>

			<Field label="Checkbox impostazioni default:">
				<Checkbox
					checked={isDefault}
					onChange={(ev, data) => setIsDefault(data.checked)}
					label="Checked"
				/>
			</Field>

			{/* <div
			// className="pass-selector"
			>
				<label>
					<input
						type="radio"
						name="passType"
						value="apple"
						checked={passType === "apple"}
						onChange={() => setPassType("apple")}
					/>
					Apple Wallet
				</label>
				<label>
					<input
						type="radio"
						name="passType"
						value="google"
						checked={passType === "google"}
						onChange={() => setPassType("google")}
					/>
					Google Wallet
				</label>
			</div> */}

			{/* Form per la raccolta dei dati */}
			<form
			// className="pass-form"
			>
				<div
					style={{
						display: "flex",
						flexDirection: "column",
						maxWidth: "300px",
						marginBottom: "10px",
					}}
				>
					<Label
					// htmlFor={inputIds.default}
					>
						Serial Number:
					</Label>
					<Input
						// className="input"
						appearance="outline"
						placeholder="Numero seriale"
						name="serialNumber"
						value={formData.serialNumber}
						onChange={handleChange}
					/>
				</div>
				<div
					style={{
						display: "flex",
						flexDirection: "column",
						maxWidth: "300px",
						marginBottom: "10px",
					}}
				>
					<Label>Organization Name:</Label>
					<Input
						appearance="outline"
						placeholder="Nome azienda"
						name="organizationName"
						value={formData.organizationName}
						onChange={handleChange}
						required
					/>
				</div>
				<div
					style={{
						display: "flex",
						flexDirection: "column",
						maxWidth: "300px",
						marginBottom: "10px",
					}}
				>
					<Label>Description:</Label>
					<Input
						appearance="outline"
						placeholder="Descrizione del pass"
						name="description"
						value={formData.description}
						onChange={handleChange}
						required
					/>
				</div>
				<div
					style={{
						display: "flex",
						flexDirection: "column",
						maxWidth: "300px",
						marginBottom: "10px",
					}}
				>
					<Label>Logo Text:</Label>
					<Input
						appearance="outline"
						placeholder=""
						name="es. Marro Grill & Pizza"
						value={formData.logoText}
						onChange={handleChange}
					/>
				</div>
				<div
					style={{
						display: "flex",
						flexDirection: "column",
						maxWidth: "300px",
						marginBottom: "10px",
					}}
				>
					<Label>Background Color:</Label>
					<ColorPickerPopup onColorSelected={setBackgroundColor} />
					<p>Colore scelto: {backgroundColor}</p>
				</div>
				<div
					style={{
						display: "flex",
						flexDirection: "column",
						maxWidth: "300px",
						marginBottom: "10px",
					}}
				>
					<Label>Foreground Color:</Label>
					<ColorPickerPopup onColorSelected={setForegroundColor} />
					<p>Colore scelto: {foregroundColor}</p>
				</div>
				<div
					style={{
						display: "flex",
						flexDirection: "column",
						maxWidth: "300px",
						marginBottom: "10px",
					}}
				>
					<Label>Label Color:</Label>
					<ColorPickerPopup onColorSelected={setLabelColor} />
					<p>Colore scelto: {labelColor}</p>
				</div>
				<div
					style={{
						display: "flex",
						flexDirection: "column",
						maxWidth: "300px",
						marginBottom: "10px",
					}}
				>
					<Label>Barcode Message:</Label>
					<Input
						appearance="outline"
						placeholder=""
						name="barcodeMessage"
						value={formData.barcodeMessage}
						onChange={handleChange}
						required
					/>
				</div>

				{/* Campi specifici per Google Wallet */}
				{passType === "google" && (
					<>
						<div
							style={{
								display: "flex",
								flexDirection: "column",
								maxWidth: "300px",
								marginBottom: "10px",
							}}
						>
							<Label>Account ID:</Label>
							<Input
								appearance="outline"
								name="accountId"
								value={formData.accountId}
								onChange={handleChange}
								required
							/>
						</div>
						<div
							style={{
								display: "flex",
								flexDirection: "column",
								maxWidth: "300px",
								marginBottom: "10px",
							}}
						>
							<Label>Account Name:</Label>
							<Input
								appearance="outline"
								name="accountName"
								value={formData.accountName}
								onChange={handleChange}
								required
							/>
						</div>
						<div
							style={{
								display: "flex",
								flexDirection: "column",
								maxWidth: "300px",
								marginBottom: "10px",
							}}
						>
							<Label>Issuer Name:</Label>
							<Input
								appearance="outline"
								name="issuerName"
								value={formData.issuerName}
								onChange={handleChange}
								required
							/>
						</div>
						<div
							style={{
								display: "flex",
								flexDirection: "column",
								maxWidth: "300px",
								marginBottom: "10px",
							}}
						>
							<Label>Program Name:</Label>
							<Input
								appearance="outline"
								name="programName"
								value={formData.programName}
								onChange={handleChange}
								required
							/>
						</div>
					</>
				)}

				<hr />

				<h3>Carica Asset Grafici</h3>
				<div
					style={{
						display: "flex",
						flexDirection: "row",
						marginBottom: "10px",
						alignItems: "center",
					}}
				>
					<Label>Icon (PNG):</Label>
					<FileInputWithPreview
						name="iconFile"
						accept="image/png,image/jpeg,image/jpg"
						// onChange={handleFileChange}
						onFileSelected={(file) =>
							// console.log("File selezionato:", file)
							handleFileChange(file)
						}
						buttonText="Carica Icona"
					/>
				</div>
				<div
					style={{
						display: "flex",
						flexDirection: "row",
						marginBottom: "10px",
						alignItems: "center",
					}}
				>
					<Label>Logo (PNG):</Label>
					<FileInputWithPreview
						name="logoFile"
						accept="image/png,image/jpeg,image/jpg"
						// onChange={handleFileChange}
						onFileSelected={(file) =>
							// console.log("File selezionato:", file)
							handleFileChange(file)
						}
						buttonText="Carica Logo"
					/>
				</div>
				<div
					style={{
						display: "flex",
						flexDirection: "row",
						marginBottom: "10px",
						alignItems: "center",
					}}
				>
					<Label>Strip (PNG):</Label>
					<FileInputWithPreview
						name="stripFile"
						accept="image/png,image/jpeg,image/jpg"
						// onChange={handleFileChange}
						onFileSelected={(file) =>
							// console.log("File selezionato:", file)
							handleFileChange(file)
						}
						buttonText="Carica Icona"
					/>
				</div>

				<hr />

				<h3>Carica Codice QR</h3>
				<div
					style={{
						display: "flex",
						flexDirection: "row",
						marginBottom: "10px",
						alignItems: "center",
					}}
				>
					<Label>QR Code (Immagine o PDF):</Label>
					<FileInputWithPreview
						name="qrCodeFile"
						accept="image/*,application/pdf"
						// onChange={handleFileChange}
						onFileSelected={(file) =>
							// console.log("File selezionato:", file)
							handleFileChange(file)
						}
						buttonText="Carica QR Code"
					/>
				</div>

				{/* <button type="submit">Genera Pass</button> */}
				<Button
					appearance="primary"
					className="login-button"
					onClick={handleSubmit}
				>
					Genera Pass
				</Button>
			</form>

			{/* Se presente, visualizza il link per il download del pass */}
			{downloadUrl && (
				<div
				// className="download-section"
				>
					<h2>Pass generato</h2>
					<p>
						<a href={downloadUrl} target="_blank" rel="noopener noreferrer">
							Scarica il pass
						</a>
					</p>
				</div>
			)}
		</div>
	);
}

export default PassGenerator;
